import { connect } from 'react-redux'
import VideoViewer from './viewer.js'
import { browserHistory } from 'react-router';

import { recordSessionAnalyticsEvent, captureNewVideoRange, updateVideoRange, removeVideoRange, syncAssetVideoRange } from 'src/redux/actions/assets.ts';

const mapStateToProps = (state, ownProps) => {
  return {
    session: state.asset.session.id,
    ranges: state.asset.session.ranges,
    asset: state.asset.item,
    account: state.accounts.item
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    recordSessionAnalyticsEvent: (event) => {
      return dispatch(recordSessionAnalyticsEvent(event));
    },

    captureNewVideoRange: (startRange) =>{
      return dispatch(captureNewVideoRange(startRange))
    },

    updateVideoRange: (id, endRange) => {
      dispatch(updateVideoRange({id, endRange, updatedDate : new Date().getTime()}));
    },

    removeVideoRange: (id) => {
      dispatch(removeVideoRange(id));
    },

    syncAssetVideoRange: (rangeId, event) => {
      return dispatch(syncAssetVideoRange({ id : rangeId, event}));
    }
  }
}

const VideoContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoViewer)

export default VideoContainer;